import React from 'react'
import { connect } from 'react-redux'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'
import AggregatedActivity from 'components/activity/AggregatedActivity'
import PleaseWait from 'components/PleaseWait'
import GroupTertiaryError from './GroupTertiaryError'
import styles from './GroupActivityList.css'
import { ListContainer } from './ListContainer'

const AggregatedActivityList = ({ you, content, order, entities = {} }) => {
  return (
    <ListContainer className={styles.group_activity_list}>
    {
      order.map(id => {
        const group = content[id]
        return (
          <AggregatedActivity
            key={id}
            you={you}
            group={group}
            entities={entities}
          />
        )
      })
    }
    </ListContainer>
  )
}

const NothingToShow = () => <PleaseWait i18nKey="group.no_activity" />

const GroupActivity = ({ you, content, order, entities, loading, error }) => {
  const loaded = content
    ? {
      you,
      content,
      order,
      entities
    }
    : null
  return (
    <LoadingLoadedOrExploded
      loading={loading}
      error={error && error.message}
      loaded={loaded}
      loadedComponent={
        loaded && loaded.order && loaded.order.length
          ? AggregatedActivityList
          : NothingToShow
      }
      errorComponent={GroupTertiaryError}
    />
  )
}

const mapStateToProps = ({
  session: { value: you },
  activities: {
    group: {
      extra: entities,
      map: content,
      list: { loading, error, values: order, range } = {}
    }
  }
}) => ({ you, content, order, entities, loading, error })

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(GroupActivity)
